import CalendarObject from "./calendar";
// import Litepicker from "../litepicker";
import Notify from "../notify";

export default class EditObject {
    constructor() {
        this.settings = {
            calendarId: "object-edit-calendar"
        }

        this.initCallendar();

    }

    initCallendar() {
        if ($("#" + this.settings.calendarId).length) {
            const calendar = new CalendarObject(this.settings.calendarId, false, false, true, true);
            calendar.init();
        }

    }

}

(function() {

    new EditObject();

})(jQuery);